import { AjaxService } from 'NewAngular/services/core/ajax.service';
import { UrlsService } from 'NewAngular/services/core/urls.service';
import * as i0 from "@angular/core";
import * as i1 from "NewAngular/services/core/ajax.service";
import * as i2 from "NewAngular/services/core/urls.service";
export class AddeparIntegrationService {
    constructor(ajaxService, urlsService) {
        this.ajaxService = ajaxService;
        this.urlsService = urlsService;
    }
    getAddeparIntegrationStatus() {
        const url = this.urlsService.INTEGRATIONS.ADDEPAR_INTEGRATION_STATUS;
        return this.ajaxService.getDataObserveBody(url);
    }
    deactivateAddeparIntegration() {
        const url = this.urlsService.INTEGRATIONS.ADDEPAR_INTEGRATION_AUTH;
        return this.ajaxService.deleteDataObserveResponse(url);
    }
    getAddeparSearchResults(searchType, searchTerms, page) {
        const url = `${this.urlsService.getUrl(this.urlsService.INTEGRATIONS.ADDEPAR_SEARCH, {
            searchType,
        })}?searchTerms=${searchTerms}&page=${page}`;
        return this.ajaxService.getDataObserveBody(url);
    }
    getAddeparGroupMembersResults(groupID, page) {
        const url = `${this.urlsService.getUrl(this.urlsService.INTEGRATIONS.ADDEPAR_GROUP_MEMBERS, {
            groupID,
        })}?page=${page}`;
        return this.ajaxService.getDataObserveBody(url);
    }
    getAddeparChildEntitiesResults(groupID, entityID, page) {
        const url = `${this.urlsService.getUrl(this.urlsService.INTEGRATIONS.ADDEPAR_ENTITY_CHILDREN, {
            groupID,
            entityID,
        })}?page=${page}`;
        return this.ajaxService.getDataObserveBody(url);
    }
    importAddeparHoldings(postParams) {
        const url = this.urlsService.INTEGRATIONS.ADDEPAR_IMPORT_HOLDINGS;
        return this.ajaxService.postJsonDataObserveBody(url, postParams);
    }
    importAddeparCustomSecurity(entityId) {
        const url = this.urlsService.INTEGRATIONS.ADDEPAR_IMPORT_CUSTOM_SECURITY;
        return this.ajaxService.postJsonDataObserveBody(url, { entityId });
    }
}
AddeparIntegrationService.ɵfac = function AddeparIntegrationService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || AddeparIntegrationService)(i0.ɵɵinject(i1.AjaxService), i0.ɵɵinject(i2.UrlsService)); };
AddeparIntegrationService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: AddeparIntegrationService, factory: AddeparIntegrationService.ɵfac, providedIn: 'root' });
